import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  Label
} from 'recharts'
import _ from 'lodash'
import { numeralFormat } from '../../../../../../../lib/renderUtil'
import XAxisLabel from '../../../../../Common/NewDashboard/Chart/XAxisLabel/XAxisLabel'
import YAxisLabel from '../../../../../Common/NewDashboard/Chart/YAxisLabel/YAxisLabel'
import YAxisTick from '../../../../../Common/NewDashboard/Chart/YAxisTick/YAxisTick'
import CustomizedLegend from '../../../../../Common/NewDashboard/Chart/Legend/Legend'
import CustomizedTooltip from './CustomizedTooltip/CustomizedTooltip'
import CustomizedXAxisTick from './CustomizedXAxisTick/CustomizedXAxisTick'

/**
 * referralGroup types provided by API
 * https://git.ouryahoo.com/TW-Shopping-BackOffice/component_shopping_spa_doc/blob/master/website.sp/content/api/resources/dashboard.mdx#pageview
 */
export const INTERNAL_SORT = [
  '首頁',
  '搜尋結果頁',
  '賣場頁',
  '新型態賣場頁',
  '每日好康',
  '時時樂',
  '分類頁',
  '活動頁',
  '其他'
]
export const EXTERNAL_SORT = [
  'Line',
  'Facebook',
  '比價網',
  'Google付費廣告',
  '搜尋引擎 (SEO-Google)',
  '搜尋引擎 (SEO-Yahoo)',
  'Yahoo 商城',
  'Yahoo 拍賣',
  'Yahoo',
  '其他',
  // below are new added for GA referralType = externalSession
  'Google Organic',
  'Yahoo Organic',
  'Others'
]
const EXTERNAL_X_AXIS_NAMES_LIST = [
  ['Line'],
  ['Facebook'],
  ['比價網'],
  ['Google', '付費廣告'],
  ['搜尋引擎', '(SEO-Google)'],
  ['搜尋引擎', '(SEO-Yahoo)'],
  ['Yahoo', '商城'],
  ['Yahoo', '拍賣'],
  ['Yahoo'],
  ['其他']
]
const EXTERNAL_X_AXIS_NAMES_LIST_MAPPING = _.reduce(
  EXTERNAL_X_AXIS_NAMES_LIST,
  (mapping, names, index) => {
    _.set(mapping, EXTERNAL_SORT[index], names)
    return mapping
  }, {}
)

const ViewsChart = props => {
  const {
    data,
    isComparison,
    isExternal,
    isExternalSession,
    barsName: [mainBarName, comparisonBarName]
  } = props
  return (
    <ResponsiveContainer
      width='100%'
      height='100%'
      minHeight='390px'
    >
      <BarChart
        data={data}
        margin={{ top: 30, left: 21, right: 21, bottom: 50 }}
      >
        <CartesianGrid
          vertical={false}
          stroke='#f5f5f5'
        />
        <XAxis
          dataKey='referralGroup'
          interval={0}
          axisLine={{ stroke: 'none' }}
          tickLine={false}
          tick={(
            <CustomizedXAxisTick
              isExternal={isExternal}
              namesMapping={EXTERNAL_X_AXIS_NAMES_LIST_MAPPING}
            />
          )}
        >
          <Label
            value='瀏覽量來源'
            offset={isExternal ? 16 : 8}
            position='bottom'
            content={<XAxisLabel />}
          />
        </XAxis>
        <YAxis
          dataKey='mainPageView'
          axisLine={false}
          tickLine={false}
          tick={(
            <YAxisTick
              customizeTickValue={value => numeralFormat(value, { allowZero: true })}
              textAnchor='end'
            />
          )}
        >
          <Label
            value={isExternalSession ? '工作階段' : '瀏覽量'}
            offset={20}
            position='left'
            angle={-90}
            content={<YAxisLabel />}
          />
        </YAxis>
        <Tooltip
          cursor={{
            fill: '#f1f1f5'
          }}
          content={(
            <CustomizedTooltip
              isComparison={isComparison}
              isExternalSession={isExternalSession}
            />
          )}
        />
        {
          isComparison && (
            <Legend
              align='left'
              verticalAlign='top'
              wrapperStyle={{
                top: 0,
                color: '#464e56'
              }}
              layoutType='vertical'
              content={<CustomizedLegend />}
            />
          )}
        <Bar
          name={mainBarName}
          dataKey='mainPageView'
          fill='#5b8ff9'
          legendType='square'
          barSize={isComparison ? 25 : 50}
        />
        {
          isComparison && (
            <Bar
              name={comparisonBarName}
              dataKey='comparisonPageView'
              fill='#5ad8a6'
              legendType='square'
              barSize={25}
            />
          )}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default ViewsChart
